import React, { useContext } from "react";
import { Route, Navigate } from "react-router-dom";
import NoPageFound from "../NoPageFound";
import Article from "../Articles/index";
import ArticleList from "../Articles/ArticleList";
import PreviewArticle from "../Articles/PreviewArticle";
import SubmitIssue from "../SubmitIssue/SubmitIssue";
import Categories from "../Categories/Categories";
import LoginPage from "../Login/LoginPage";
import SearchPage from "../AISearch";
import { KBContext } from "../../Context";
import { isFeatureEnabled } from "../../utils";
import { FTR_KB_AI_SEARCH } from "../../Constants";

function AISearchRouteGuard() {
  const { availableFeatures } = useContext(KBContext);
  if (!isFeatureEnabled(FTR_KB_AI_SEARCH, availableFeatures)) {
    return <Navigate to="/" replace />;
  }
  return <SearchPage />;
}

export function getHomeRoutes() {
  return (
    <>
      <Route path="/" element={<Categories />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/search" element={<AISearchRouteGuard />} />
      <Route path="submit-issue" element={<SubmitIssue />} />
      <Route path="not-found" element={<NoPageFound />} />
      <Route element={<Article />}>
        <Route path="/:categorySlug" element={<ArticleList />} />
        <Route path="/:categorySlug/:articleSlug" element={<PreviewArticle />} />
      </Route>
    </>
  );
}
